import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function FeaturedCarousel() {
  const slides = newsList.slice(0, 4);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const go = (i: number) => setIndex((i + slides.length) % slides.length);

  return (
    <section className="w-full">
      <div className="relative w-full h-[280px] md:h-[420px] rounded-lg overflow-hidden bg-foreground-900">
        {slides.map((item, i) => (
          <div
            key={item.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          >
            <img src={item.cover} alt={item.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-8">
              <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium mb-3">
                <i className="ri-fire-line"></i> 焦点新闻
              </span>
              <h3 className="text-lg md:text-2xl font-bold text-white max-w-3xl leading-snug">{item.title}</h3>
              <p className="hidden md:block text-sm text-white/80 mt-2 max-w-2xl line-clamp-2">{item.summary}</p>
              <div className="flex items-center gap-4 mt-4 text-xs text-white/70">
                <span className="flex items-center gap-1"><i className="ri-calendar-line"></i> {item.date}</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i> {item.views} 次浏览</span>
                <Link
                  to={`/news/${item.id}`}
                  className="ml-auto inline-flex items-center gap-1 text-sm text-white hover:text-accent-300 transition-colors"
                >
                  阅读全文 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        ))}

        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(index - 1)}
          className="absolute left-3 md:left-5 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 rounded-full bg-black/35 text-white flex items-center justify-center hover:bg-black/55 transition-colors"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(index + 1)}
          className="absolute right-3 md:right-5 top-1/2 -translate-y-1/2 w-9 h-9 md:w-10 md:h-10 rounded-full bg-black/35 text-white flex items-center justify-center hover:bg-black/55 transition-colors"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>

        <div className="absolute bottom-5 right-5 md:right-8 flex items-center gap-2">
          {slides.map((item, i) => (
            <button
              key={item.id}
              type="button"
              aria-label={`第 ${i + 1} 张`}
              onClick={() => go(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === index ? "w-6 bg-accent-500" : "w-2 bg-white/60"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}